export enum ReportType {
  KPI = 'KPI',
  VILD = 'VILD'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/reporttype.ts